import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Top Section */}
      <section className="pt-24 md:pt-28 pb-12 md:pb-16 bg-white">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 text-center">
          <div className="text-[#D97642] text-sm font-semibold uppercase tracking-wider mb-4">
            OUR SERVICES
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] leading-tight mb-6">
            Operational Transport Support for Logistics Operators
          </h1>
          <p className="text-base md:text-lg text-[#5A5A5A] max-w-[750px] mx-auto">
            CLOG TRANSPORT provides structured subcontract transport support designed to integrate seamlessly into established logistics and freight operations across Darwin and the Northern Territory.
          </p>
          <p className="text-sm md:text-base text-[#7A7A7A] max-w-[650px] mx-auto mt-4">
            We operate strictly as a B2B operational partner, supporting logistics companies with additional capacity when required.
          </p>
        </div>
      </section>

      {/* Main Service Card */}
      <section className="pb-12 md:pb-16">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="w-full md:max-w-[70%] mx-auto bg-white border-2 border-gray-200 rounded-2xl p-8 sm:p-12 md:p-16 shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">
              <div>
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1A2B4A] leading-tight mb-4">
                  Subcontract Transport Support
                </h2>
                <p className="text-sm md:text-base text-[#5A5A5A] leading-relaxed">
                  Our core service is the provision of operational transport capacity to established logistics operators. Our role is to strengthen your operational capability without increasing your internal overhead or long-term asset risk.
                </p>
              </div>

              <div>
                <p className="text-xs uppercase tracking-wider text-[#9A9A9A] font-semibold mb-5">We support partners through:</p>
                <div className="space-y-5">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-2xl text-[#D97642]"></i>
                    </div>
                    <p className="text-base md:text-lg text-[#4A4A4A]">
                      Dedicated vehicle and professional driver supply
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-2xl text-[#D97642]"></i>
                    </div>
                    <p className="text-base md:text-lg text-[#4A4A4A]">
                      Long-term operational support
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-2xl text-[#D97642]"></i>
                    </div>
                    <p className="text-base md:text-lg text-[#4A4A4A]">
                      Peak demand capacity assistance
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-2xl text-[#D97642]"></i>
                    </div>
                    <p className="text-base md:text-lg text-[#4A4A4A]">
                      Integration into existing dispatch and compliance systems
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-2xl text-[#D97642]"></i>
                    </div>
                    <p className="text-base md:text-lg text-[#4A4A4A]">
                      Reliable, presentation-focused operational representation
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Future Service Section */}
      <section className="pb-20 md:pb-28">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="w-full md:max-w-[60%] mx-auto bg-[#F5F5F5] border-2 border-dashed border-gray-300 rounded-2xl p-8 sm:p-10 md:p-12 text-center">
            <div className="inline-block bg-[#D97642] text-white text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-6">
              FUTURE EXPANSION
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2C2C2C] mb-3">
              Selective Regional NT Transport Solutions
            </h3>
            <p className="text-base md:text-lg text-[#5A5A5A] mb-6">
              Darwin to Katherine and beyond
            </p>
            <p className="text-sm text-[#7A7A7A] max-w-[500px] mx-auto">
              As operational capacity grows and partnerships strengthen, CLOG TRANSPORT may expand into selective regional transport routes within the Northern Territory. Any expansion will be demand-driven and carefully structured to maintain the reliability, operational standards and partnership focus that define our service model.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
